import React, {useState, useEffect} from "react";
import FreeDeliveryBanner from "./FreeDeliveryBanner";
import useFreeDeliveryBanner from "./useFreeDeliveryBanner";
import currentTheme from "../../../react-themes/theme";
import FreeDeliveryBannerContentCatalogPdp from "./FreeDeliveryBannerContentCatalogPdp";

const theme = currentTheme();
const FreeDeliveryBannerDesktopCatalogPdp = (props) => {
  const {showBanner, freeDeliveryBannerName, closeBannerDesktop} = useFreeDeliveryBanner();
  const [display, setDisplay] = useState(false);

  const onClose = () => {
    closeBannerDesktop();
  };

  useEffect(() => {
    if (!freeDeliveryBannerName?.length) return;
    if (showBanner && freeDeliveryBannerName === "FreeDeliveryBanner:CatalogPdp") {
      setDisplay(true);
    } else {
      setDisplay(false);
      closeBannerDesktop();
    }
  }, [showBanner, freeDeliveryBannerName]);

  const parentProps = {
    onClose,
    name: freeDeliveryBannerName,
    Content: FreeDeliveryBannerContentCatalogPdp
  };

  return (
    <div
      className={"position-relative overflow-hidden full-width"}
      style={{
        zIndex: 8000,
        transition: `height ${theme.transitionTime.medium}ms`,
        height: display ? "47px" : 0
      }}
    >
      <div
        className={"full-width position-fixed"}
        style={{
          height: "47px",
          zIndex: 8010,
          transition: `top ${theme.transitionTime.medium}ms`,
          top: display ? 0 : "-47px"
        }}
      >
        <FreeDeliveryBanner {...parentProps}/>
      </div>
      <div
        className={"full-width position-relative"}
        style={{
          transition: `height ${theme.transitionTime.medium}ms`,
          height: display ? "47px" : 0
        }}
      ></div>
    </div>);
};

export default FreeDeliveryBannerDesktopCatalogPdp;
